<template>
  <router-view :key="$route.path"></router-view>
</template>

<script>
export default {
  name: 'Auksjoner'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Auctions.vue